<template>
    <div class="content">
        <div class="hw-content">
            <div class="content-head-title">订单[{{ OrdersSN }}]附件上传</div>
            <div class="mb20" v-for="(item, index) in list" :key="index">
                <div v-if="item.Orders_Type == 1">
                    <div class="error" v-if="item.Upload == 'false'">[{{ item.Orders_SN }}]: {{ item.Message }}</div>
                    <el-descriptions v-else title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="订单号">
                            <div class="rows">{{ item.Orders_SN }}</div>
                        </el-descriptions-item>
                        <el-descriptions-item label="订单类型">
                            <div class="rows">{{ item.DiscountCateName }}</div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <div v-if="item.Orders_Type == 2">
                    <div class="error" v-if="item.Upload == 'false'">
                        {{ item.Message }}
                    </div>
                    <el-descriptions v-else title="" :column="2" border size="medium" labelClassName="custom-label">
                        <el-descriptions-item label="退货单号">
                            <div class="rows">{{ item.Orders_SN }}</div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </div>
            <div v-if="relate_orders.length > 0 || relate_orders_backbill.length > 0">
                <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                    <el-descriptions-item label="合同附件">
                        <div style="width: 300px">
                            <Hwupload ref="Hwupload" @ontempList="ontempList"></Hwupload>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
                <div class="button-container">
                    <el-button type="primary" @click="submit">保存</el-button>
                    <el-button type="primary" @click="goBack">返回</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Hwupload from '@/components/Hwupload/indexMany';

export default {
    components: {
        Hwupload
    },
    props: {
        orderOperate: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            fileList: [],
            OrdersID: '', //合同id
            OrdersSN: '', //合同SN
            OrdersAuditStatus: '', //合同审核状态
            batchOrderId: '', //当前选中的订单id
            relate_orders: [],
            backbillOrderId: '', //当前选中的退货单id
            list: [],
            relate_orders_backbill: []
        };
    },
    mounted() {
        if (this.orderOperate) {
            this.OrdersID = this.orderOperate.OrdersID;
            this.OrdersSN = this.orderOperate.OrdersSN;
            this.OrdersAuditStatus = this.orderOperate.OrdersAuditStatus;
            this.batchOrderId = this.orderOperate.batchId;
            this.backbillOrderId = this.orderOperate.backbillOrderId;
            this.CheckSPCOrdersBatchAttachment();
        }
        // const params = this.$route.query;
        // if (params) {
        //     this.OrdersID = params.OrdersID;
        //     this.OrdersSN = params.OrdersSN;
        //     this.OrdersAuditStatus = params.OrdersAuditStatus;
        //     this.batchOrderId = params.batchId;
        //     this.backbillOrderId = params.backbillOrderId;
        //     this.CheckSPCOrdersBatchAttachment(this.id);
        // }
    },
    methods: {
        ontempList(list) {
            this.fileList = list;
            console.log(list);
        },
        // 批量上传检查
        async CheckSPCOrdersBatchAttachment() {
            var result = await this.$newsApi.order.CheckSPCOrdersBatchAttachment({
                OrdersID: this.OrdersID,
                relate_orders: this.batchOrderId,
                relate_orders_backbill: this.backbillOrderId
            });
             //alert(result.data.Resultinfo);
            this.list = result.data.data;
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].Upload == 'true') {
                    if (this.list[i].Orders_Type == 1) {
                        this.relate_orders.push(this.list[i].Orders_ID);
                    } else if (this.list[i].Orders_Type == 2) {
                        this.relate_orders_backbill.push(this.list[i].Orders_ID);
                    }
                }
            }
        },
        goBack() {
            // this.$router.push({
            //     path: '/orderManagement/contractmanagementDetails',
            //     query: {
            //         id: this.OrdersID
            //     }
            // });
            this.$emit('BatchUploadRes', false);
        },
        // 保存
        async submit() {
            let json = {};
            json.Orders_Attachment = this.fileList.join('|');
            json.relate_orders = this.relate_orders.join();
            json.relate_orders_backbill = this.relate_orders_backbill.join();
            json = JSON.stringify(json);
            let result = await this.$newsApi.order.SPCOrders_Attachment_Edit({
                OrdersID: this.OrdersID,
                Json: json
            });
            if (result.data.Resultcode == 0) {
                this.$message.success('保存成功');
                // this.$router.go(-1);
                this.$emit('BatchUploadRes', true);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
}
.hw-content {
    padding: 20px;
}

/* 通用样式 */
.rows {
    width: 389px;
}
.links {
    color: #409eff;
    cursor: pointer;
}
.red {
    color: #f56c6c;
    margin-right: 10px;
}
.distributeBox {
    /deep/.is-center,
    .el-table__cell {
        padding: 0;
    }
    /deep/.cell {
        padding: 0;
    }
}

.office-box {
    .no-border-table {
        border: none; /* 去掉表格的四周边框 */
    }

    .no-border-table .el-table__header,
    .no-border-table .el-table__body {
        border: none; /* 去掉表头和表体的边框 */
    }

    .no-border-table .el-table__row {
        border: none; /* 去掉表格行的边框 */
    }
    /deep/.is-center,
    /deep/.el-table__cell {
        height: 25px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
.flex {
    display: flex;
    align-items: center;
}
.mb20 {
    margin-bottom: 20px;
}
.error {
    color: red;
    font-weight: 700;
    margin-bottom: 20px;
}
.content,
.hw-content {
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

::v-deep .el-dialog {
    overflow: hidden !important;
   overflow-y: hidden !important;
}

::v-deep .el-dialog__body {
    overflow: hidden !important;
    overflow-y: hidden !important;
}
</style>
